"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalBarChart = void 0;
var react_1 = __importStar(require("react"));
var DonutChart_1 = require("./DonutChart");
var Normalizer_1 = require("./Normalizer");
var react_dom_1 = require("react-dom");
function BarRender(_a) {
    var item = _a.item, ratio = _a.ratio, faded = _a.faded;
    return react_1.default.createElement("tr", null,
        react_1.default.createElement("td", { style: { opacity: faded ? .5 : 1, transition: "opacity .3s" } },
            react_1.default.createElement("span", { "data-item": item.label }, item.label)),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: "horizontal-bar ".concat(item.style, " bg-color"), style: { transition: "opacity .3s", width: ratio.toFixed(2) + '%', opacity: faded ? .5 : 1 }, "data-item": item.label })));
}
function HorizontalBarChart(_a) {
    var data = _a.data, _b = _a.tooltip, tooltip = _b === void 0 ? null : _b;
    var _c = (0, react_1.useState)(null), item = _c[0], setItem = _c[1];
    var _d = (0, react_1.useState)(null), tooltipContent = _d[0], setTooltipContent = _d[1];
    var _e = (0, react_1.useState)(null), tooltipPoint = _e[0], setTooltipPoint = _e[1];
    var ref = (0, react_1.useRef)();
    var info = (0, react_1.useMemo)(function () {
        var normalizer = new Normalizer_1.Normalizer('value', 100);
        normalizer.updateData(data);
        normalizer.saveMinMax();
        var diff = normalizer.max - normalizer.min;
        var newMin = normalizer.dataMin - diff * .05;
        normalizer.updateData([{ value: newMin }]);
        return { normalizer: normalizer };
    }, [data]);
    function onMouseMove(e) {
        var element = e.target;
        if ('dataset' in element && element.dataset.item !== undefined) {
            var rect = e.target.getBoundingClientRect();
            setTooltipPoint({ x: rect.left + 15, y: rect.top + 25 });
            setItem(element.dataset.item);
            return;
        }
    }
    (0, react_1.useEffect)(function () {
        if (item === null) {
            setTooltipContent(null);
            return;
        }
        var n = data.find(function (a) { return a.label == item; });
        setTooltipContent(tooltip ? tooltip(n) : react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "me-2" },
                n.label,
                ":"),
            " ",
            n.value));
        ref.current.focus();
    }, [item]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("table", { ref: ref, className: "horizontal-bar-chart chart-color-set", onMouseMove: onMouseMove, tabIndex: -1, onBlur: function () { return setItem(null); }, onMouseLeave: function () { return setItem(null); } },
            react_1.default.createElement("tbody", null, data.map(function (i) { return react_1.default.createElement(BarRender, { key: i.label, item: i, ratio: info.normalizer.normalize(i.value), faded: item && item != i.label }); }))),
        (0, react_dom_1.createPortal)(react_1.default.createElement(DonutChart_1.DonutTooltip, { strategy: 'absolute', key: "tooltip", placement: "top-start", content: tooltipContent, x: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.x, y: tooltipPoint === null || tooltipPoint === void 0 ? void 0 : tooltipPoint.y }), document.body));
}
exports.HorizontalBarChart = HorizontalBarChart;
//# sourceMappingURL=HorizontalBarChart.js.map